import React, { useState } from 'react';
import { MONO } from './ui';
import { PronCard } from './PronCard';

const clean = (w) => w.replace(/[.,;:!?"]/g, '').toLowerCase();

const currentLine = (lines, time) => {
  let idx = 0;
  lines.forEach((l, i) => { if (l[0][0] <= time + 0.05) idx = i; });
  return idx;
};

// Synced captions: current line large, target words highlighted as they are spoken; tap a word for its pronunciation.
export const LiveTranscript = ({ lines, time, started, focus, testid, big, pron, pronNote, pronLabels, labDialect, t }) => {
  const [sel, setSel] = useState(null);
  if (!lines?.length) return null;
  const li = started ? currentLine(lines, time) : 0;
  const uniq = [...new Set(lines.flat().filter((w) => w[2]).map((w) => clean(w[1])))];
  const tap = (w) => (pron?.[clean(w)] ? () => setSel(clean(w)) : undefined);
  const btn = pron ? 'cursor-pointer hover:ring-2 hover:ring-amber-300' : '';
  return (
    <div className={`rounded-xl bg-black/40 border border-white/10 ${big ? 'px-8 py-6' : 'px-4 py-3'}`} data-testid={testid}>
      <div className="flex items-center justify-between gap-3 mb-2">
        <span className={`${big ? 'text-sm' : 'text-[10px]'} uppercase tracking-[0.2em] text-amber-300 font-bold`} style={MONO}>{focus}</span>
        <span className="text-[10px] text-blue-100/50" style={MONO}>{started ? `${li + 1}/${lines.length}` : `${uniq.length} ×`}</span>
      </div>
      {started ? (
        <p className={`${big ? 'text-4xl lg:text-6xl leading-tight min-h-[9rem]' : 'text-base sm:text-lg leading-relaxed min-h-[3.5rem]'} text-white/60`} data-testid={`${testid}-line`}>
          {lines[li].map(([wt, w, k], i) => {
            const said = wt <= time + 0.05;
            const cls = k ? (said ? 'text-slate-950 bg-amber-300 font-bold' : 'text-amber-200 underline decoration-amber-300/60 underline-offset-4')
              : (said ? 'text-white' : '');
            return <span key={`${wt}-${i}`} onClick={k ? tap(w) : undefined} className={`px-0.5 rounded transition-colors duration-150 ${cls} ${k ? btn : ''}`} data-testid={k ? 'transcript-keyword' : undefined}>{w} </span>;
          })}
        </p>
      ) : (
        <p className="flex flex-wrap gap-1.5" data-testid={`${testid}-keywords`}>
          {uniq.map((w) => <span key={w} onClick={tap(w)} className={`px-2 py-0.5 rounded-md bg-amber-300/15 text-amber-200 ${big ? 'text-2xl' : 'text-sm'} font-semibold ${btn}`} data-testid={`keyword-chip-${w}`}>{w}</span>)}
        </p>
      )}
      {sel && <PronCard word={sel} pron={pron[sel]} note={pronNote} labels={pronLabels} labDialect={labDialect} t={t} onClose={() => setSel(null)} />}
    </div>
  );
};
